import axios from 'axios';

import * as utils from '../utils/utils.js';

export const updateVenue = async (
    venue_id,
    owner_id,
    name,
    image_url,
    latitude,
    longitude
) => {
    const session_url = utils.backendUrl() + '/venue';
    try {
        const response = await axios.patch(
            session_url,
            {
                venue_id: venue_id,
                owner_id: owner_id,
                name: name,
                image_url: image_url,
                latitude: latitude,
                longitude: longitude,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );
        return response.data;
    } catch (err) {
        console.error('myerr', err.message);
        console.error(err.response);
        throw err;
    }
};
